import { styled } from "~/common/mui";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";
import { useTranslation } from "react-i18next";

export const SectionTitle = styled("h3")({
  ...getFontStyle(FontSize.HeadlineSmall),
  margin: 0,
});

export const Section = styled("div")({
  "& + &": {
    marginTop: "30px",
  },
  "& > * + *": {
    marginTop: "20px",
  },
});

export const MandatoryMessage = (props: Omit<JSX.IntrinsicElements["div"], "children">) => {
  const { t } = useTranslation();
  return <div {...props}>{t("page.completeRegistration.mandatory")}</div>;
};
